import React, { useRef, useState } from "react"
import { removeItemSummaryQueue, selectLstSummaryQueue } from "../../redux/reducers/slice/event"
import { useDispatch, useSelector } from "react-redux"
import Modal from "antd/lib/modal"
import { ILuckyWheelSummaryModel } from "../../models/eventModel"
import clsx from "clsx"

const PopupHighlight = React.memo((props: IProps) => {
  const dispatch = useDispatch();
  const lstSummaryQueue = useSelector(selectLstSummaryQueue)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [current, setCurrent] = useState<ILuckyWheelSummaryModel>()
  const refTimeout = useRef<NodeJS.Timeout>()

  React.useEffect(() => {
    getCurrent()
  }, [lstSummaryQueue])

  const getCurrent = () => {
    if (!isOpen && lstSummaryQueue?.length) {
      const _current = lstSummaryQueue[0]
      setCurrent(_current)
      setIsOpen(true)
      refTimeout.current = setTimeout(() => {
        handleClose(_current._id)
      }, 30000)
    }
  }


  const handleClose = (id?: string) => {
    setIsOpen(false)
    dispatch(removeItemSummaryQueue(id))
    if (refTimeout.current) {
      clearTimeout(refTimeout.current);
    }
  }

  const renderGift = () => {
    if (!current) {
      return <></>
    }
    if (current.is_special) {
      return <>
        <div className="highlight-title">Trúng vàng tài lộc <br />phú quý cả năm</div>
        <div className="highlight-subtitle">{current?.extra}</div>
      </>
    } else {
      return <>
        <div className="highlight-title">TRÚNG THƯỞNG <br />{current.gift_name}</div>
        <div className="highlight-subtitle">{current?.extra}</div>
      </>
    }
  }

  return <>
    <Modal
      className="md-event-highlight"
      visible={isOpen}
      title={null}
      footer={null}
      closable={false}
      width={props?.isTVDevice ? 1045 : 877}
      centered
    >
      <div className="highlight-container">
        <div className="highlight-wrapper">
          <div className="btn-close-wrapper" onClick={() => handleClose(current?._id)}>
            <div></div>
          </div>
          <div className={clsx("customer-and-title", { "special": current?.is_special })}>
            <div className="highlight-customer">Quý khách <span>{current?.customer_name}</span></div>
            {renderGift()}
          </div>
          <div className="highlight-order">Mã đơn hàng: {current?.kde_order_id}</div>
        </div>
      </div>
    </Modal>
  </>
})

export default PopupHighlight

interface IProps {
  isTVDevice: boolean
}